import { gql } from '@apollo/client';

export const GET_ACTIVITY_CANCELLATION_CLOSURE_REASONS = gql`
  query GetActivityCancellationAndClosureReasons {
    vm {
      activityCancellationReasons {
        activityCancellationReasonId
        label
      }
      activityClosureReasons {
        activityClosureReasonId
        label
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_SESSION_VISIBILITY = gql `
  query GetAdminConsoleOpsSessionVisibility {
    vm {
      configItem(key: "operations-allow-roster-session-visibility") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_CALENDAR_INVITES = gql`
  query GetAdminConsoleOpsCalendarInvites {
    vm {
      configItem(key: "operations-calendar-invites-enabled") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ASSIGNED_ROSTERING_VIEW = gql`
  query GetAdminConsoleOpsAssignedRosteringView {
    vm {
      configItem(key: "operations-assigned-rostering-view") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_AVAILABILITY_RESTRICTION = gql`
  query GetAdminConsoleOpsAvailabilityRestriction {
    tm {
      tenant {
        config {
          availabilityRestrictionDays
        }
      }
    }
  }
`;
